export default {
    android: {
        link: "https://play.google.com/store/apps/details?id=com.ydangleapps.Flick",
        title: "Android",
        subtitle: 'Android 5 and up'
    },
    ios: {
        link: "https://itunes.apple.com/us/app/flick./id644265534",
        title: "iOS",
        subtitle: 'iPhone, iPad'
    },
    linux: {
        link: "https://s3-us-west-2.amazonaws.com/getflick.io/Flick.1.0.3.zip",
        title: "Linux",
        subtitle: 'Java based'
    },
    macOS: {
        link: "https://itunes.apple.com/us/app/flick./id646740026",
        title: "macOS",
        subtitle: 'OS X 10.7 or later'
    },
    windowsLegacy: {
        link: "https://ydangleapps.s3.amazonaws.com/flick-windows-installer.exe",
        title: "Windows",
        subtitle: "XP, Vista, 7, 8, 10"
    },
    windowsUniversal: {
        link: "https://www.microsoft.com/en-us/p/flick/9wzdncrd8b38",
        title: "Windows",
        subtitle: "Universal Windows Platform",
    },
    "beta-android": {
        link: "https://play.google.com/apps/testing/com.ydangleapps.Flick",
        title: "Android Beta",
    },
    "beta-ios": {
        link: "https://testflight.apple.com/join/2yuGwRmQ",
        title: "iOS Beta"
    }
};